import React, { useState } from 'react';
import './Contact.css';

export const Contact = () => {
  const [formData, setFormData] = useState({
    fullname: "",
    email: "",
    phone: "",
    subject: "",
    description: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { fullname, email, phone, subject, description } = formData;

    if (!fullname || !email || !phone || !subject || !description) {
      alert("Please fill in all fields.");
      return;
    }

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email)) {
      alert("Please enter a valid email address.");
      return;
    }

    const phonePattern = /^\d{10}$/;
    if (!phonePattern.test(phone)) {
      alert("Please enter a valid 10-digit phone number.");
      return;
    }

    try {
      const response = await fetch("/send-email", {
        // 👈 use your backend endpoint
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (response.ok) {
        alert(result.message || "Message sent successfully!");
        setFormData({
          fullname: "",
          email: "",
          phone: "",
          subject: "",
          description: "",
        });
      } else {
        alert(result.message || "Failed to send message.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong. Please try again later.");
    }
  };



  return (
    <div>
      {/* Header */}
      <div className="jumbotron jumbotron-fluid page-header position-relative overlay-bottom" style={{ marginBottom: '90px', minHeight: '400px' }}>
        <div className="container text-center py-5" style={{ marginTop: "-80px" }}>
          <h1 className="text-white display-1 mb-4" style={{ fontSize: '4rem', fontWeight: 'bold', textShadow: '2px 2px 4px rgba(0,0,0,0.3)' }}>Get In Touch</h1>
          <p className="text-white lead mb-4" style={{ fontSize: '1.3rem', opacity: '0.9' }}>
            We'd love to hear from you. Send us a message and we'll respond as soon as possible.
          </p>
          <div className="d-inline-flex text-white mb-5">
            <p className="m-0 text-uppercase"><a className="text-white" href="/" style={{ textDecoration: 'none' }}>Home</a></p>
            <i className="fa fa-angle-double-right pt-1 px-3"></i>
            <p className="m-0 text-uppercase">Contact</p>
          </div>
        </div>
      </div>

      {/* Why Choose Us Section */}
      <div className="container-fluid py-5 bg-light" style={{ marginTop: "-150px" }}>
        <div className="container py-5">
          <div className="row">
            <div className="col-12 text-center mb-5">
              <div className="section-title position-relative">
                <h6 className="d-inline-block position-relative text-secondary text-uppercase pb-2">Why Contact Us?</h6>
                <h1 className="display-4 mb-4">We're Here to Help You Succeed</h1>
                <p className="lead text-muted">
                  At BDM Technology, we believe in building lasting relationships with our clients through exceptional service and support.
                </p>
              </div>
            </div>
          </div>
          
          <div className="row">
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="bg-white rounded shadow-sm p-4 h-100 text-center" style={{ transition: 'transform 0.3s ease', cursor: 'pointer' }} 
                   onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-10px)'}
                   onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}>
                <div className="btn-icon bg-primary mx-auto mb-3" style={{ width: '80px', height: '80px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <i className="fa fa-3x fa-rocket text-white"></i>
                </div>
                <h4 className="mb-3">Quick Response</h4>
                <p className="text-muted">We respond to all inquiries within 24 hours. Your time is valuable, and we respect that.</p>
              </div>
            </div>
            
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="bg-white rounded shadow-sm p-4 h-100 text-center" style={{ transition: 'transform 0.3s ease', cursor: 'pointer' }} 
                   onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-10px)'}
                   onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}>
                <div className="btn-icon bg-secondary mx-auto mb-3" style={{ width: '80px', height: '80px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <i className="fa fa-3x fa-users text-white"></i>
                </div>
                <h4 className="mb-3">Expert Team</h4>
                <p className="text-muted">Our experienced professionals are ready to provide you with the best solutions for your needs.</p>
              </div>
            </div>
            
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="bg-white rounded shadow-sm p-4 h-100 text-center" style={{ transition: 'transform 0.3s ease', cursor: 'pointer' }} 
                   onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-10px)'}
                   onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}>
                <div className="btn-icon bg-warning mx-auto mb-3" style={{ width: '80px', height: '80px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <i className="fa fa-3x fa-handshake text-white"></i>
                </div>
                <h4 className="mb-3">Personalized Service</h4>
                <p className="text-muted">Every client is unique. We tailor our approach to meet your specific requirements and goals.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Methods Section */}
      <div className="container-fluid py-5" style={{ background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)' }}>
        <div className="container py-5">
          <div className="row">
            <div className="col-12 text-center mb-5">
              <div className="section-title position-relative">
                <h6 className="d-inline-block position-relative text-secondary text-uppercase pb-2">Multiple Ways to Connect</h6>
                <h1 className="display-4 mb-4">Choose Your Preferred Method</h1>
              </div>
            </div>
          </div>
          
          <div className="row justify-content-center">
            <div className="col-lg-3 col-md-6 mb-4">
              <div className="bg-white rounded shadow p-4 text-center h-100">
                <div className="btn-icon bg-primary mx-auto mb-3" style={{ width: '60px', height: '60px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <i className="fa fa-2x fa-phone text-white"></i>
                </div>
                <h5 className="mb-3">Call Us</h5>
                <p className="text-muted mb-3">Speak directly with our team</p>
                <a href="tel:+919600700103" className="btn btn-outline-primary btn-sm">+91 7892343219</a>
              </div>
            </div>
            
            <div className="col-lg-3 col-md-6 mb-4">
              <div className="bg-white rounded shadow p-4 text-center h-100">
                <div className="btn-icon bg-success mx-auto mb-3" style={{ width: '60px', height: '60px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <i className="fa fa-2x fa-envelope text-white"></i>
                </div>
                <h5 className="mb-3">Email Us</h5>
                <p className="text-muted mb-3">Send us a detailed message</p>
             <a 
  href="mailto:info@bdmtech.in" 
  className="btn btn-outline-success btn-sm"
>
  retools@retools.in
</a>




              </div>
            </div>
            
            <div className="col-lg-3 col-md-6 mb-4">
  <div className="bg-white rounded shadow p-4 text-center h-100">
    <div
      className="btn-icon bg-info mx-auto mb-3"
      style={{
        width: '60px',
        height: '60px',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <i className="fa fa-2x fa-map-marker-alt text-white"></i>
    </div>
    <h5 className="mb-3">Visit Us</h5>
    <p className="text-muted mb-3">Come to our office</p>
    <a
      href="https://www.google.com/maps/@12.996189,77.699052,106m/data=!3m1!1e3?hl=en&entry=ttu&g_ep=EgoyMDI1MDgxOS4wIKXMDSoASAFQAw%3D%3D"
      target="_blank"
      rel="noopener noreferrer"
      className="btn btn-outline-info btn-sm"
    >
      Get Directions
    </a>
  </div>
</div>

            
            {/* <div className="col-lg-3 col-md-6 mb-4">
              <div className="bg-white rounded shadow p-4 text-center h-100">
                <div className="btn-icon bg-warning mx-auto mb-3" style={{ width: '60px', height: '60px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <i className="fa fa-2x fa-comments text-white"></i>
                </div>
                <h5 className="mb-3">Live Chat</h5>
                <p className="text-muted mb-3">Real-time assistance</p>
                <button className="btn btn-outline-warning btn-sm">Start Chat</button>
              </div>
            </div> */}
          </div>
        </div>
      </div>

      {/* Main Contact Section */}
      <div className="container-fluid py-5">
        <div className="container py-5">
          <div className="row align-items-center">
            <div className="container py-5">
  <div className="row align-items-stretch">

    {/* Contact Info */}
    <div className="col-lg-5 mb-4">
      <div className="bg-light d-flex flex-column justify-content-center px-4 py-5 rounded shadow-sm h-100">
        <div className="text-center mb-4">
          <h3 className="text-primary mb-3">Contact Information</h3>
          <p className="text-muted">Get in touch with us through any of these channels</p>
        </div>

      {[
  { icon: "fa-map-marker-alt", bg: "primary", title: "Our Location", desc: "NO B-26 2ND CROSS, (NEXT PHOENIX MARKET CITY) ITI ANCILLARY INDUSTRIAL ESTATE MAHADEVAPURA, BENGALURU - 560048" },
  { icon: "fa-phone-alt", bg: "secondary", title: "Call Us", desc: "+91 7892343219", sub: "Mon - Fri: 9:00 AM - 6:00 PM" },
  { icon: "fa-envelope", bg: "warning", title: "Email Us", desc: "retools@retools.in", sub: "We'll respond within 24 hours" },
  { icon: "fa-clock", bg: "success", title: "Business Hours", desc: "Monday - Friday: 9:00 AM - 6:00 PM", sub: "Saturday: 9:00 AM - 2:00 PM" }
].map((item, index) => (
  <div
    key={index}
    className="d-flex align-items-center mb-4"
    style={{
      paddingLeft: "50px",   // ✅ small shift right
      paddingRight: "12px"   // keeps text balanced
    }}
  >
    <div
      className={`btn-icon bg-${item.bg} me-3`}
      style={{
        minWidth: "60px",
        height: "60px",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      <i className={`fa fa-2x ${item.icon} text-white`}></i>
    </div>
    <div>
      <h5 className="mb-1">{item.title}</h5>
      <p className="m-0 text-muted">{item.desc}</p>
      {item.sub && <small className="text-muted">{item.sub}</small>}
    </div>
  </div>
))}

      </div>
    </div>

    {/* Contact Form */}
    <div className="col-lg-7">
      <div className="bg-white rounded shadow-sm p-4 h-100">
        <h4 className="text-dark mb-4">Send Us A Message</h4>
        {/* 👇 bind the handler */}
        <form onSubmit={handleSubmit}>
          <div className="row g-3">
            <div className="col-md-6">
              <input
                type="text"
                name="fullname"
                className="form-control"
                placeholder="Full Name *"
                value={formData.fullname}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <input
                type="email"
                name="email"
                className="form-control"
                placeholder="Email Address *"
                value={formData.email}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <input
                type="tel"
                name="phone"
                className="form-control"
                placeholder="Phone Number *"
                value={formData.phone}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <input
                type="text"
                name="subject"
                className="form-control"
                placeholder="Subject *"
                value={formData.subject}
                onChange={handleChange}
              />
            </div>
            <div className="col-12">
              <textarea
                name="description"
                className="form-control"
                rows="4"
                placeholder="Message *"
                value={formData.description}
                onChange={handleChange}
              ></textarea>
            </div>
            <div className="col-12">
              <button type="submit" className="btn btn-primary px-4">
                Send Message
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
 

  </div>
</div>


           
          </div>
        </div>
      </div>

      {/* FAQ Section */}
      <div className="container-fluid py-5 bg-light">
        <div className="container py-5">
          <div className="row">
            <div className="col-12 text-center mb-5">
              <div className="section-title position-relative">
                <h6 className="d-inline-block position-relative text-secondary text-uppercase pb-2">Common Questions</h6>
                <h1 className="display-4 mb-4">Frequently Asked Questions</h1>
                <p className="lead text-muted">
                  Find quick answers to the most common questions about our services and processes.
                </p>
              </div>
            </div>
          </div>
          
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="accordion" id="faqAccordion">
                <div className="card border-0 shadow-sm mb-3">
                  <div className="card-header bg-white border-0" id="faq1">
                    <h5 className="mb-0">
                      <button className="btn btn-link text-left text-decoration-none w-100 p-3" type="button" data-toggle="collapse" data-target="#collapse1">
                        <i className="fa fa-plus mr-3 text-primary"></i>
                        How quickly do you respond to inquiries?
                      </button>
                    </h5>
                  </div>
                  <div id="collapse1" className="collapse" data-parent="#faqAccordion">
                    <div className="card-body text-muted">
                      We respond to all inquiries within 24 hours during business days. For urgent matters, please call us directly at +91 96007 00103.
                    </div>
                  </div>
                </div>
                
                <div className="card border-0 shadow-sm mb-3">
                  <div className="card-header bg-white border-0" id="faq2">
                    <h5 className="mb-0">
                      <button className="btn btn-link text-left text-decoration-none w-100 p-3" type="button" data-toggle="collapse" data-target="#collapse2">
                        <i className="fa fa-plus mr-3 text-primary"></i>
                        What services do you offer?
                      </button>
                    </h5>
                  </div>
                  <div id="collapse2" className="collapse" data-parent="#faqAccordion">
                    <div className="card-body text-muted">
                      BDM Technology offers comprehensive IT solutions including software development, web design, digital marketing, and IT consulting services.
                    </div>
                  </div>
                </div>
                
                <div className="card border-0 shadow-sm mb-3">
                  <div className="card-header bg-white border-0" id="faq3">
                    <h5 className="mb-0">
                      <button className="btn btn-link text-left text-decoration-none w-100 p-3" type="button" data-toggle="collapse" data-target="#collapse3">
                        <i className="fa fa-plus mr-3 text-primary"></i>
                        Do you offer free consultations?
                      </button>
                    </h5>
                  </div>
                  <div id="collapse3" className="collapse" data-parent="#faqAccordion">
                    <div className="card-body text-muted">
                      Yes, we offer free initial consultations to understand your requirements and provide the best solution for your business needs.
                    </div>
                  </div>
                </div>
                
                <div className="card border-0 shadow-sm mb-3">
                  <div className="card-header bg-white border-0" id="faq4">
                    <h5 className="mb-0">
                      <button className="btn btn-link text-left text-decoration-none w-100 p-3" type="button" data-toggle="collapse" data-target="#collapse4">
                        <i className="fa fa-plus mr-3 text-primary"></i>
                        What are your business hours?
                      </button>
                    </h5>
                  </div>
                  <div id="collapse4" className="collapse" data-parent="#faqAccordion">
                    <div className="card-body text-muted">
                      We're open Monday through Friday from 9:00 AM to 6:00 PM, and Saturday from 9:00 AM to 2:00 PM. We're closed on Sundays.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Map Section */}
      <div className="container-fluid py-5">
        <div className="container py-5">
          <div className="map-wrapper text-center">
            <div className="section-title position-relative mb-5">
              <h6 className="d-inline-block position-relative text-secondary text-uppercase pb-2">Find Us</h6>
              <h1 className="display-4 mb-4">Visit Us at RAMESH ENTERPRISES</h1>
              <p className="lead text-muted mx-auto" style={{ maxWidth: '600px' }}>
                Looking to connect with us in person? We're located in the heart of the city! Find us easily using the map below. 
                Whether you're planning a visit, attending a training, or just stopping by — we're happy to welcome you at BDM Technology.
              </p>
            </div>

            <div className="map-container rounded shadow-lg overflow-hidden" style={{ transition: 'transform 0.3s ease' }}
                 onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
                 onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}>
            <iframe
  src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d230.9539418029724!2d77.6990517066043!3d12.99618872929837!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e1!3m2!1sen!2sin!4v1753168961803!5m2!1sen!2sin"
  width="100%"
  height="400"
  style={{ border: 0 }}
  allowFullScreen
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
  title="Google Map Location"
/>

            </div>
            
            <div className="row mt-5">
              <div className="col-md-4 text-center mb-4">
                <div className="bg-primary text-white rounded-circle mx-auto mb-3" style={{ width: '80px', height: '80px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <i className="fa fa-2x fa-car"></i>
                </div>
                <h5>Parking Available</h5>
                <p className="text-muted">Free parking space available for visitors</p>
              </div>
              
              <div className="col-md-4 text-center mb-4">
                <div className="bg-success text-white rounded-circle mx-auto mb-3" style={{ width: '80px', height: '80px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <i className="fa fa-2x fa-bus"></i>
                </div>
                <h5>Public Transport</h5>
                <p className="text-muted">Easily accessible by bus and auto-rickshaw</p>
              </div>
              
              <div className="col-md-4 text-center mb-4">
                <div className="bg-warning text-white rounded-circle mx-auto mb-3" style={{ width: '80px', height: '80px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <i className="fa fa-2x fa-wheelchair"></i>
                </div>
                <h5>Accessible</h5>
                <p className="text-muted">Wheelchair accessible entrance and facilities</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Call to Action Section */}
      <div className="container-fluid py-5" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
        <div className="container py-5">
          <div className="row align-items-center">
            <div className="col-lg-8">
              <h2 className="text-white mb-3">Ready to Get Started?</h2>
              <p className="text-white lead mb-4">
                Don't wait any longer. Contact us today and let's discuss how we can help you achieve your goals. 
                Our team is ready to provide you with the best solutions tailored to your needs.
              </p>
            </div>
            <div className="col-lg-4 text-center">
              <a href="tel:+919600700103" className="btn btn-light btn-lg rounded-pill px-5 py-3 mr-3 mb-3" style={{ fontWeight: 'bold' }}>
                <i className="fa fa-phone mr-2"></i>
                Call Now
              </a>
              <a href="mailto:info@bdmtech.in" className="btn btn-outline-light btn-lg rounded-pill px-5 py-3 mb-3" style={{ fontWeight: 'bold' }}>
                <i className="fa fa-envelope mr-2"></i>
                Email Us
              </a>
            </div>
          </div>
        </div>
      </div>

      

    </div>
  );
};